import Insight from "../insightClass";
import React from "react";
import { insight13Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight077 = new Insight(
  "14 November 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight13Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-11-14)",
  "",
  `ScottishPower Renewables has completed the full repowering of the Hagshaw Hill wind farm in South Lanarkshire, Scotland’s first commercial wind project. The site’s original 26 turbines have been replaced with 14 modern, higher-capacity units, lifting total capacity to approximately 79MW and increasing annual generation by a factor of five—enough to power around 57,000 homes.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-11-14)</h1>
    <h2></h2>
    <p className="article-date">14 November 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>
      1. Scotland’s First Commercial Wind Farm Repowered, Delivering Five Times
      More Clean Energy
    </h3>
    <p>
      ScottishPower Renewables has completed the full repowering of the Hagshaw
      Hill wind farm in South Lanarkshire, Scotland’s first commercial wind
      project. The site’s original 26 turbines have been replaced with 14
      modern, higher-capacity units, lifting total capacity to approximately
      79MW and increasing annual generation by a factor of five—enough to power
      around 57,000 homes. The repowering process supported roughly 100 jobs
      during decommissioning and construction. Notably, all blades from the
      original turbines will be fully recycled by Plaswire into construction
      materials, replacing concrete, timber, and plastics and marking one of the
      UK’s most comprehensive circular-economy applications in wind.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Hagshaw Hill demonstrates how early-generation wind farms can unlock
      substantial new output through “fewer-but-larger” turbines without placing
      additional stress on grid capacity or land use. For offshore wind, where
      major projects built in the early 2000s will approach end-of-life in the
      2030s, this case offers important lessons for repowering strategy,
      decommissioning planning, and supply-chain capacity for blade recycling.
      It also highlights the socio-economic advantage of repowering versus
      retirement, providing long-term benefits in employment and local value
      creation.
    </p>
    <h3>2. Shell Exits Two Scottish Floating Offshore Wind Projects</h3>
    <p>
      Shell has withdrawn from two floating offshore wind projects off
      Scotland’s northeast coast. The company transferred its stake in the 3GW
      MarramWind project to ScottishPower and subsequently handed back the 2GW
      CampionWind lease to Crown Estate Scotland. The move reflects Shell’s
      strategic shift toward lower-risk, less capital-intensive power
      businesses, as floating wind—still at a pre-commercial stage—faces
      elevated costs, limited supply-chain readiness, and significant
      development uncertainties.The Financial Times additionally reports that
      China’s Ming Yang is collaborating with ORE Catapult on turbine testing in
      Scotland and may consider a £1.5bn manufacturing investment, indicating
      intensifying global supply-chain competition in the UK market.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Shell’s exit underscores the selective approach international energy
      companies are now taking toward floating wind. For ScotWind, the return of
      a major lease introduces uncertainty around project sequencing and
      investor confidence. Meanwhile, the growing presence of Asian OEMs in the
      UK will likely accelerate policy discussions around localisation,
      technology screening, and supply-chain resilience. Future projects may see
      stricter requirements for local manufacturing and greater scrutiny of
      foreign suppliers.
    </p>
    <h3>
      3. UK Firms Form Alliance to Strengthen Floating Wind Assembly and
      Logistics
    </h3>
    <p>
      Two UK companies have launched a new alliance to provide integrated
      heavy-lift, transport, and turbine-to-floater assembly services for
      floating offshore wind, according to 4C Offshore. The
      partnership—featuring heavy-lifting specialist Sarens PSG—aims to offer
      end-to-end support from marshalling to tow-out operations. Floating
      projects require significantly more complex port operations compared with
      fixed-bottom projects, including large-scale storage, precision mating of
      turbine components, and coordinated tow-out scheduling.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      As floating wind transitions toward commercial-scale deployment, project
      success increasingly depends on port-centric integration and efficient
      assembly sequencing. Developers are shifting from fragmented procurement
      to consolidated service models that can reduce interface risk and improve
      schedule reliability. UK ports competing to become floating-wind hubs—such
      as Cromarty Firth, Port Talbot, and Aberdeen—stand to benefit from turnkey
      alliances that offer proven heavy-lift and assembly capabilities. Over
      time, British expertise in floating assembly could become an exportable
      service offering for Japan, Korea, Spain, and the US West Coast.
    </p>
    <h3>
      4. Global Floating Wind Capacity Up 13%, With the UK and China Emerging as
      Key Growth Drivers
    </h3>
    <p>
      RenewableUK’s latest EnergyPulse report shows that global floating
      offshore wind capacity increased by 13% over the past year, reaching
      277MW. Norway leads with 100MW, followed by the UK with 78MW and China
      with 40MW. Despite the small absolute scale, the project pipeline is
      accelerating rapidly: global floating capacity could reach 2.5GW by 2030,
      with Europe representing approximately 60% of announced projects (134GW).
      The UK alone accounts for 31GW across 39 projects, 84% of which are
      located in Scottish waters.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Floating wind is moving beyond demonstration phases and into early
      industrialisation. Norway, the UK, and China represent three distinct
      development models—technology-led, auction-driven, and policy-driven
      respectively—shaping different risk-reward profiles for developers. The
      UK’s large pipeline relative to its small operational base highlights an
      execution gap, with potential bottlenecks in port infrastructure,
      moorings, cables, and specialised vessels. Despite higher costs, floating
      wind will remain strategically important for deep-water countries seeking
      long-term decarbonisation solutions.
    </p>
    <h3>
      5. RWE Hits Milestone at Sofia as AI-Driven Data Centres Boost Renewable
      Demand
    </h3>
    <p>
      RWE has completed installation of fully recyclable blades across all
      turbines at the 1.4GW Sofia offshore wind farm in the UK North Sea. The
      project is one of the first globally to commit to full-fleet recyclable
      blades, improving long-term sustainability and reducing future
      decommissioning burdens.At the same time, RWE reported €225m in one-off
      gains from selling a UK data-centre site, helping the company exceed
      earnings expectations. The transaction highlights a growing trend:
      AI-driven data-centre expansion is increasing demand for secure, long-term
      renewable power, positioning offshore wind as a preferred source for
      corporate PPAs.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Circular-design components such as recyclable blades are rapidly
      transitioning from pilot concepts to mainstream practice and will
      increasingly influence future permitting and auction frameworks.
      Meanwhile, AI and cloud-computing data centres—with stable loads and low
      price sensitivity—are poised to become major offshore wind buyers. Hybrid
      revenue models combining CfDs and corporate PPAs may offer improved
      financial resilience for large-scale North Sea projects.
    </p>
    <h3>
      6. Former Petrofac CEO Seeks £40m to Stabilise Offshore Wind Venture
      Venterra Group
    </h3>
    <p>
      A former Petrofac chief executive is seeking approximately £40m to
      stabilise an offshore wind venture he established several years ago,
      according to 4C Offshore. The business has faced financial pressure due to
      project delays, tightening award conditions, and rising financing costs.
      The capital raise is primarily intended to preserve core capabilities
      rather than fund expansion.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Financial stress is becoming more visible across segments of the offshore
      wind supply chain, particularly among mid-sized engineering, vessel, and
      service providers with limited balance-sheet resilience. Developers are
      increasingly prioritising contractor financial health when awarding major
      packages. Consolidation—through distressed acquisitions or
      restructurings—is likely over the next 12–24 months. For project owners,
      conducting supply-chain stress tests and maintaining alternative
      contractor options is becoming essential.
    </p>
    <h3>
      7. Japan’s Eneos Warns of Rising Costs at the 375MW Happo-Noshiro Offshore
      Project
    </h3>
    <p>
      Japan’s Eneos Holdings has cautioned that returns from its 375MW
      Happo-Noshiro offshore wind project in Akita Prefecture may come under
      pressure due to rising costs, although the project remains on schedule.
      Japan has already seen several offshore wind project withdrawals driven by
      financial concerns. Despite these challenges, the country continues to
      target 10GW of offshore wind by 2030 and 45GW by 2040.Japanese offshore
      wind development is characterised by high capital expenditure, challenging
      port and vessel availability, and stringent engineering
      requirements—including typhoon and seismic resilience standards—which
      increase overall project complexity.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Japan is one of Asia’s most technically demanding offshore wind markets.
      Developers face strict engineering, environmental, and financial
      requirements, while shallow-water resources are limited, increasing
      reliance on floating solutions over time. The Akita projects will serve as
      test beds for seismic design, port logistics, and environmental assessment
      practices in the region. Policy adjustments—such as auction reforms or tax
      incentives—are likely as Japan seeks to maintain investment momentum.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
